import { connect } from 'react-redux';
import { getLoaders } from 'selectors';
import { updateGroupCohortsByOrganizationType } from 'actions/partner';
import { getColumnsAges } from 'selectors';
import GroupCohortsTable from 'components/reports/byorganizationtype/GroupCohortsTable';

const mapStateToProps = (state) => {
  return {
    ages: getColumnsAges(state.filters.ages),
    auth: state.auth,
    isLoading: getLoaders(state, ['REPORT_GROUP_COHORT_BY_ORGANIZATION_TYPE_FILTER', 'REPORT_GROUP_COHORT_BY_ORGANIZATION_TYPE']),
    data: state.reports.groupCohortsByOrganizationType,
    meta: state.meta.groupCohortsByOrganizationType,
    accountPlayers: state.accountPlayers,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onPageChange: (page) => {
      dispatch(updateGroupCohortsByOrganizationType({page}))
    },
  }
}

const GroupCohortsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupCohortsTable)

export default GroupCohortsContainer;
